module.exports = __webpack_public_path__ + "static/img/room_unavailable.b940b3e0.png";